import { gql } from '@apollo/client'

export default gql`
    mutation createZipDownloadOrderDetails($orderName: String!) {
        createZipDownloadOrderDetails(orderName: $orderName) {
            id
            jobStartDate
            jobCompleteDate
            name
            error
            url
        }
    }
`
